export class KeyedAsyncQueue<TKey> {
  #continuationByKey = new Map<TKey, Promise<void>>();

  async enqueue<TResult>(key: TKey, operation: () => Promise<TResult>): Promise<TResult> {
    const previousContinuation = this.#continuationByKey.get(key) ?? Promise.resolve();
    const result = previousContinuation.then(operation);

    // Keep the chain fulfilled so one rejection does not block later operations for this key.
    const continuation = result.then(
      () => {},
      () => {},
    );

    this.#continuationByKey.set(key, continuation);

    try {
      return await result;
    } finally {
      if (this.#continuationByKey.get(key) === continuation) {
        this.#continuationByKey.delete(key);
      }
    }
  }

  clear(): void {
    // Accepted operations retain their own promise chains and are not cancelled.
    this.#continuationByKey.clear();
  }
}
